import { render, staticRenderFns } from "./AddDivergentModal.vue?vue&type=template&id=0c705dd0&scoped=true"
import script from "./AddDivergentModal.vue?vue&type=script&lang=js"
export * from "./AddDivergentModal.vue?vue&type=script&lang=js"
import style0 from "./AddDivergentModal.vue?vue&type=style&index=0&id=0c705dd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c705dd0",
  null
  
)

export default component.exports